import { render } from "./PatternSymbolIcon.vue?vue&type=template&id=7c21b49c"
import script from "./PatternSymbolIcon.vue?vue&type=script&lang=js"
export * from "./PatternSymbolIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__